import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import { CheckBox, DataGrid, SelectBox, Template } from "devextreme-react";
import {
  Column,
  Export,
  Grouping,
  GroupPanel,
  HeaderFilter,
  Pager,
  Paging,
  SearchPanel,
  SortByGroupSummaryInfo,
} from "devextreme-react/data-grid";
import { DateFormat, RegEx, StatusType } from "../../helpers/fixcodes";
import Modal from "react-modal";
import { toast } from "react-toastify";
import RadioGroup from "devextreme-react/radio-group";
import { askConfirmation, showResponseMessage } from "../../helpers/message";
import {
  axiosGet,
  axiosPost,
  axiosPostWithParamBody,
} from "../../apis/useAxios";

const airlineTypeLst = [
  { id: 1, text: "Domestic" },
  { id: 2, text: "International" },
  { id: 3, text: "Both" },
];
export default function CrewActivityCodeComponent(props) {
  const [state, setState] = useState({
    activityCodeGridDataSource: [],
    saveActivityCode: {
      openModal: false,
      activityCodeId: 0,
      activity: null,
    },
  });
  const refDataGrid = useRef(null);
  useLayoutEffect(() => {
    document.querySelector("#lblPageTitle").innerHTML = `Crew - Activity Code`;
  }, []);
  let isUseEffectRendered = false;
  useEffect(() => {
    const controller = new AbortController();
    try {
      if (isUseEffectRendered) {
        return;
      }
      fetGridDataOnPageLoad();
      return () => {
        controller.abort();
        isUseEffectRendered = true;
      };
    } catch (error) {
      console.log(error);
    }
  }, []);
  const fetGridDataOnPageLoad = () => {
    try {
      setTimeout(async () => {
        await getCrewActivityCodeList();
      }, 0);
    } catch (error) {
      console.log(error);
    }
  };
  const getCrewActivityCodeList = async () => {
    try {
      if (refDataGrid.current?.instance)
        refDataGrid.current.instance.beginCustomLoading();
      let apiUrl = `CrewActivity/${sessionStorage.getItem("session_airlineCode")}/${
        props?.activityTypeId ?? 0
      }/non-fly-activity-code-list`;
      const response = await axiosGet(apiUrl);
      setState((prev) => ({
        ...prev,
        activityCodeGridDataSource: response?.payload ?? [],
      }));
      if (refDataGrid.current?.instance) {
        refDataGrid.current.instance.endCustomLoading();
        // refDataGrid.current.instance.refresh();
        // refDataGrid.current.instance.repaint();
      }
    } catch (error) {
      console.log(error);
      if (refDataGrid.current?.instance) {
        refDataGrid.current.instance.endCustomLoading();
      }
    }
  };

  return (
    <>
      <style>{`
        /* ── Activity Code — theme matching sidebar #fff0e6 ── */
        .ca-grid-wrap .dx-header-row td {
          background-color: #fff0e6 !important;
          color: #000000 !important;
          font-size: 0.76rem !important;
          font-weight: 600 !important;
          letter-spacing: 0.02em !important;
          border-color: rgba(255,255,255,0.15) !important;
        }
        .ca-grid-wrap .dx-datagrid-filter-row td {
          background-color: #f5ede4 !important;
        }
        .ca-grid-wrap .dx-datagrid {
          border-radius: 8px !important;
          overflow: hidden !important;
          box-shadow: 0 2px 10px rgba(142,100,72,0.1) !important;
        }
        .ca-grid-wrap .dx-toolbar {
          background: #fdf7f2 !important;
          border-bottom: 1px solid #e8d5c4 !important;
          padding: 0.35rem 0.6rem !important;
        }
      `}</style>
      <div className="card ca-grid-wrap">
        <div className="card-body">
          <DataGrid
            ref={refDataGrid}
            dataSource={state.activityCodeGridDataSource}
            columnsAutoWidth={true}
            showColumnLines={true}
            showRowLines={true}
            showBorders={true}
            rowAlternationEnabled={false}
            allowColumnResizing={true}
            onCellPrepared={(e) => {
              if (e.rowType === "header") {
                e.cellElement.style.backgroundColor = "#fff0e6";
                e.cellElement.style.color = "#000000";
              }
            }}
            onToolbarPreparing={(e) => {
              e.toolbarOptions.items.unshift(
                {
                  location: "after",
                  template: "toolbarAddActivityCodeTemplate",
                },
                {
                  location: "after",
                  widget: "dxButton",
                  options: {
                    icon: "refresh",
                    onClick: async (e) => {
                      e.component.option("icon", "fas fa-spinner fa-spin");
                      await getCrewActivityCodeList();
                      e.component.option("icon", "refresh");
                    },
                  },
                },
              );
            }}
          >
            <Template
              name="toolbarAddActivityCodeTemplate"
              render={() => {
                return (
                  <>
                    <button
                      style={{ height: "35px" }}
                      type="button"
                      title="Activity Code"
                      className="btn btn-primary btn-sm"
                      onClick={() => {
                        setState((prev) => ({
                          ...prev,
                          saveActivityCode: {
                            openModal: true,
                            activityCodeId: 0,
                            activity: null,
                          },
                        }));
                      }}
                    >
                      <i className="fas fa-plus">
                        &nbsp;&nbsp;Add Activity Code&nbsp;&nbsp;
                      </i>
                    </button>
                  </>
                );
              }}
            />
            <Column
              dataField="activityCodeId"
              caption=""
              allowSorting={false}
              allowSearch={false}
              allowExporting={false}
              allowFiltering={false}
              fixed={true}
              width={"45"}
              cellRender={(data) => {
                return (
                  <a
                    href="#"
                    title="Update Activity Code"
                    onClick={(e) => {
                      e.preventDefault();
                      setState((prev) => ({
                        ...prev,
                        saveActivityCode: {
                          openModal: true,
                          activityCodeId: data.data.activityCodeId,
                          activity: data.data,
                        },
                      }));
                    }}
                    className="btn-link"
                  >
                    <i style={{ cursor: "pointer" }} className="fas fa-edit" />
                  </a>
                );
              }}
            />
            <Column
              dataField="activityCode"
              caption="Activity Code"
              allowSearch={true}
              headerFilter={{ allowSearch: true }}
            />
            <Column
              dataField="activityName"
              caption="Activity"
              allowSearch={true}
              headerFilter={{ allowSearch: true }}
            />
            <Column
              dataField="airlineType"
              caption="Sector"
              visible={false}
              allowSearch={true}
              headerFilter={{ allowSearch: true }}
              cellRender={(data) => {
                let airlineTypes = data.data?.airlineType?.split(",");
                let domestic =
                  airlineTypes?.length > 0
                    ? airlineTypes.at(0).charAt(0).toUpperCase() +
                      airlineTypes.at(0).slice(1).toLowerCase()
                    : "";
                let international =
                  airlineTypes?.length > 1
                    ? airlineTypes.at(1).charAt(0).toUpperCase() +
                      airlineTypes.at(1).slice(1).toLowerCase()
                    : "";
                return (
                  <div className="mergeData ellipsis">
                    <>
                      {domestic && (
                        <>
                          <i className="fas fa-plane text-success" />
                          <span className="text-muted"> {domestic}</span>
                        </>
                      )}
                      {international && (
                        <>
                          <br />
                          {/* <i className="fas fa-plane text-primary" /> */}
                          <img
                            src="assets/img/flight-international.svg"
                            width={16}
                          />
                          <span className="text-muted"> {international}</span>
                        </>
                      )}
                    </>
                  </div>
                );
              }}
            />
            <Column
              dataField="domesticReportingMinutesText"
              caption="Domestic"
              allowSearch={true}
              headerFilter={{ allowSearch: true }}
              cellRender={(data) => {
                return (
                  <div className="mergeData ellipsis">
                    {data.data.domesticReportingMinutesText && (
                      <>
                        <i
                          title="Reporting"
                          className="fas fa-plane-departure text-success"
                        />
                        <span style={{ marginLeft: "3px" }} title="Reporting">
                          {data.data.domesticReportingMinutesText}
                        </span>
                        <span className="text-muted ml-2">Reporting</span>
                      </>
                    )}
                    {data.data.domesticDebriefMinutesText && (
                      <>
                        <br />
                        <i
                          title="Debrief"
                          className="fas fa-plane-arrival text-success"
                        />
                        <span style={{ marginLeft: "3px" }} title="Debrief">
                          {data.data.domesticDebriefMinutesText}
                        </span>
                        <span className="text-muted ml-2">Debrief</span>
                      </>
                    )}
                  </div>
                );
              }}
            />
            <Column
              dataField="internationalReportingMinutesText"
              caption="International"
              allowSearch={true}
              headerFilter={{ allowSearch: true }}
              cellRender={(data) => {
                return (
                  <div className="mergeData ellipsis">
                    {data.data.internationalReportingMinutesText && (
                      <>
                        <i
                          title="Reporting"
                          className="fas fa-plane-departure text-primary"
                        />
                        <span style={{ marginLeft: "3px" }} title="Reporting">
                          {data.data.internationalReportingMinutesText}
                        </span>
                        <span className="text-muted ml-2">Reporting</span>
                      </>
                    )}
                    {data.data.internationalDebriefMinutesText && (
                      <>
                        <br />
                        <i
                          title="Debrief"
                          className="fas fa-plane-arrival text-primary"
                        />
                        <span style={{ marginLeft: "3px" }} title="Debrief">
                          {data.data.internationalDebriefMinutesText}
                        </span>
                        <span className="text-muted ml-2">Debrief</span>
                      </>
                    )}
                  </div>
                );
              }}
            />
            <Column
              dataField="isActive"
              caption="Active"
              allowSearch={true}
              headerFilter={{ allowSearch: true }}
            />
            <Column
              dataField="createTransportOnMissingActivityLocation"
              //caption="Transport Required on Missing Activity Location"
              caption="Transport Required"
              allowSearch={true}
              headerFilter={{ allowSearch: true }}
            />
            <Column
              dataField="modifiedDate"
              caption="Modified Date"
              allowSearch={true}
              headerFilter={{ allowSearch: true }}
              format={DateFormat.DateTime24NorthFormat}
              dataType="datetime"
            />
            <SortByGroupSummaryInfo summaryItem="count" />
            <GroupPanel visible={false} />
            <HeaderFilter visible={true} />
            <SearchPanel
              visible={true}
              highlightCaseSensitive={true}
              width={240}
              placeholder="Search..."
            />
            <Grouping autoExpandAll={true} />
            <Paging defaultPageSize={10} />
            <Pager
              showPageSizeSelector={props?.activityId ? false : true}
              allowedPageSizes={[10, 15, 50]}
              showInfo={true}
              visible={true}
            />
            <Export
              enabled={true}
              allowExportSelectedData={false}
              fileName="NonFlyActivityCode"
            />
          </DataGrid>
        </div>
      </div>
      {state.saveActivityCode.openModal && (
        <SaveActivityCode
          activityCodeId={state.saveActivityCode.activityCodeId}
          activity={state.saveActivityCode.activity}
          onRefresh={async () => {
            await getCrewActivityCodeList();
          }}
          onClose={() => {
            setState((prev) => ({
              ...prev,
              saveActivityCode: {
                openModal: false,
                activityCodeId: 0,
                activity: null,
              },
            }));
          }}
        />
      )}
    </>
  );
}
export function SaveActivityCode(props) {
  const [state, setState] = useState({
    isSubmitted: false,
    activityTypeDropdownDataSource: [],
    activityTypeId: props?.activity?.activityId ?? 0,
    activityCode: props?.activity?.activityCode ?? "",
    createTransportOnMissingActivityLocation:
      props?.activity?.createTransportOnMissingActivityLocation ?? false,
    domesticReportingMinutes: props?.activity?.domesticReportingMinutes ?? 0,
    domesticDebriefMinutes: props?.activity?.domesticDebriefMinutes ?? 0,
    internationalReportingMinutes:
      props?.activity?.internationalReportingMinutes ?? 0,
    internationalDebriefMinutes:
      props?.activity?.internationalDebriefMinutes ?? 0,
    airlineTypeId: 0,
    errors: {
      activityType: "",
      activityCode: "",
    },
  });
  useLayoutEffect(() => {
    try {
      let airlineTypeId =
        (props?.activity?.isDomestic ?? false) &&
        (props?.activity?.isInternational ?? false)
          ? 3
          : (props?.activity?.isDomestic ?? false)
            ? 1
            : (props?.activity?.isInternational ?? false)
              ? 2
              : 0;
      setState((prev) => ({
        ...prev,
        airlineTypeId: airlineTypeId,
      }));
    } catch (error) {
      console.log(error);
    }
  }, []);
  const getActivityTypeList = async () => {
    try {
      let apiUrl = `${
        process.env.REACT_APP_API_BASE_URL
      }CrewActivity/${sessionStorage.getItem(
        "session_airlineCode",
      )}/activity-type-list${props.activityCodeId > 0 ? "" : "-active"}`;
      const response = await axiosGet(
        `CrewActivity/${sessionStorage.getItem(
          "session_airlineCode",
        )}/activity-type-list${props.activityCodeId > 0 ? "" : "-active"}`,
      );
      setState((prev) => ({
        ...prev,
        activityTypeDropdownDataSource: response?.payload ?? [],
      }));
    } catch (error) {
      console.log(error);
    }
  };
  const isValid = () => {
    let isValid = true;
    try {
      let err = state.errors;
      err.activityCode = "";
      err.activityType = "";
      if (!state.activityTypeId) {
        isValid = false;
        err.activityType = "Please select activity type";
      }
      if (!state.activityCode?.trim()) {
        isValid = false;
        err.activityCode = "Please enter activity code";
      }
      setState((prev) => ({ ...prev, errors: err }));
    } catch (error) {
      console.log(error);
    }
    return isValid;
  };
  const handleOnSubmitActivityCode = async () => {
    try {
      if (isValid()) {
        let isConfirmed = await askConfirmation(
          `Are you sure want to ${
            props.activityCodeId === 0 ? "add" : "update"
          }?`,
          "Yes",
          "No",
        );
        if (isConfirmed) {
          setState((prev) => ({ ...prev, isSubmitted: true }));
          let airlineTypeIds = [];
          if (state.airlineTypeId > 0) {
            if (state.airlineTypeId === 3) {
              airlineTypeIds.push(1);
              airlineTypeIds.push(2);
            } else if (state.airlineTypeId === 1) {
              airlineTypeIds.push(1);
            } else if (state.airlineTypeId === 2) {
              airlineTypeIds.push(2);
            }
          }
          const request = {};
          request.AirlineCode = sessionStorage.getItem("session_airlineCode");
          request.ActivityTypeId = state.activityTypeId;
          request.ActivityCode = state.activityCode;
          request.createTransportOnMissingActivityLocation =
            state.createTransportOnMissingActivityLocation;
          request.DomesticReportingMinutes = state.domesticReportingMinutes;
          request.DomesticDebriefMinutes = state.domesticDebriefMinutes;
          request.InternationalReportingMinutes =
            state.internationalReportingMinutes;
          request.InternationalDebriefMinutes =
            state.internationalDebriefMinutes;
          request.AirlineTypeIds = airlineTypeIds;
          request.userName = sessionStorage.getItem("session_userName");
          const response = await axiosPostWithParamBody(
            `CrewActivity/save-non-fly-activity-code`,
            { id: props.activityCodeId },
            request,
          );
          setState((prev) => ({ ...prev, isSubmitted: false }));
          if (response?.isSuccess) {
            isConfirmed = await showResponseMessage({
              isSuccess: response?.isSuccess,
              message: response?.message,
            });
            if (isConfirmed) {
              await props.onRefresh();
              props.onClose();
            }
          } else {
            toast.error(response?.message, {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 2000,
              style: { width: "310px" },
              hideProgressBar: false,
              newestOnTop: false,
              closeButton: false,
            });
          }
        }
      }
    } catch (error) {
      setState((prev) => ({ ...prev, isSubmitted: false }));
      console.log(error);
    }
  };
  return (
    <>
      <Modal
        ariaHideApp={false}
        isOpen={true}
        className={"react-modal"}
        shouldCloseOnOverlayClick={false}
        contentLabel="Example Modal"
        onAfterOpen={async () => {
          await getActivityTypeList();
        }}
        onAfterClose={() => {
          setState((prev) => ({
            ...prev,
            isSubmitted: false,
            activityCode: "",
            errors: {
              activityCode: "",
            },
          }));
        }}
        style={{ content: { width: "35%" } }}
      >
        <div className="modal-header">
          <h6 className="modal-title">
            {props.activityCodeId === 0 ? "Add" : "Update"} Activity Code
          </h6>
          <button
            type="button"
            className="close"
            data-dismiss="modal"
            aria-label="Close"
            onClick={() => {
              props.onClose();
            }}
          >
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div className="modal-body">
          <div className="row">
            <div className="col-lg-6 col-md-12 col-sm-12">
              <div className="form-group">
                <label htmlFor="activityCode">Activity Code</label>
                <SelectBox
                  dataSource={state.activityTypeDropdownDataSource}
                  className="basic-multi-select"
                  classNamePrefix="select"
                  placeholder="Select Activity Type"
                  name="activityType"
                  value={state.activityTypeId}
                  displayExpr="name"
                  valueExpr="id"
                  showClearButton={true}
                  searchEnabled={true}
                  onValueChanged={(e) => {
                    let activityTypeId = e.value ?? 0;
                    let err = state.errors;
                    err.activityType = "";
                    setState((prev) => ({
                      ...prev,
                      activityTypeId: activityTypeId,
                      errors: err,
                    }));
                  }}
                />
                {state.errors.activityType?.length > 0 && (
                  <span className="text-danger" style={{ fontSize: "small" }}>
                    {state.errors.activityType}
                  </span>
                )}
              </div>
            </div>
            <div className="col-lg-6 col-md-12 col-sm-12">
              <div className="form-group">
                <label htmlFor="activityCode">Activity Code</label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  id="activityCode"
                  name="activityCode"
                  value={state.activityCode}
                  onChange={(event) => {
                    const target = event.target;
                    const name = target.name;
                    const value = target.value;
                    const err = state.errors;
                    switch (name) {
                      case "activityCode":
                        err.activityCode = "";
                        if (value.trim() === "" || value.length <= 50) {
                          setState((prev) => ({
                            ...prev,
                            activityCode: value,
                          }));
                        }
                        break;
                      default:
                        break;
                    }
                    setState((prev) => ({ ...prev, errors: err }));
                  }}
                />
                {state.errors.activityCode?.length > 0 && (
                  <span className="text-danger" style={{ fontSize: "small" }}>
                    {state.errors.activityCode}
                  </span>
                )}
              </div>
            </div>
            <div className="col-lg-12 col-md-12 col-sm-12">
              <div className="form-group">
                <br />
                <CheckBox
                  value={state.createTransportOnMissingActivityLocation}
                  onValueChanged={(e) => {
                    setState((prev) => ({
                      ...prev,
                      createTransportOnMissingActivityLocation: e.value,
                    }));
                  }}
                />
                <label htmlFor="createTransportOnMissingActivityLocation">
                  {/* &nbsp;&nbsp;Transport Required on Missing Activity Location */}
                  &nbsp;&nbsp;Transport Required{" "}
                  <span className="text-small italic text-nowrap text-danger">
                    <i>
                      Transport will be created on Missing Activity Location
                    </i>
                  </span>
                </label>
              </div>
            </div>
            <div
              className="col-lg-12 col-md-12 col-sm-12"
              style={{ marginTop: "10px" }}
            >
              <div className="form-group">
                <label htmlFor="radio-group-with-selection">Sector</label>
                <div className="d-flex">
                  <RadioGroup
                    id="radio-group-with-selection"
                    layout="horizontal"
                    items={airlineTypeLst}
                    value={state.airlineTypeId}
                    valueExpr="id"
                    displayExpr="text"
                    onValueChanged={(e) => {
                      setState((prev) => ({
                        ...prev,
                        airlineTypeId: e.value,
                      }));
                    }}
                  />
                  <a
                    href="#"
                    className="btn-link mt-1 ml-3 text-danger font-weight-bold"
                    title="Clear"
                    onClick={(e) => {
                      e.preventDefault();
                      setState((prev) => ({
                        ...prev,
                        airlineTypeId: 0,
                      }));
                    }}
                  >
                    <i style={{ cursor: "pointer" }} className="fas fa-times" />
                    &nbsp;Clear
                  </a>
                </div>
              </div>
            </div>
            {(state.airlineTypeId === 1 || state.airlineTypeId === 3) && (
              <>
                <div className="col-lg-6 col-md-12 col-sm-12">
                  <div className="form-group">
                    <label htmlFor="reporting">
                      Domestic Reporting Minutes
                    </label>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      value={state.domesticReportingMinutes || ""}
                      onChange={(e) => {
                        let domesticReportingMinutes = e.target.value;
                        if (
                          domesticReportingMinutes.trim() === "" ||
                          RegEx.Numeric.test(domesticReportingMinutes)
                        ) {
                          if (Number(domesticReportingMinutes) < 1000) {
                            setState((prev) => ({
                              ...prev,
                              domesticReportingMinutes:
                                domesticReportingMinutes,
                            }));
                          }
                        }
                      }}
                    />
                  </div>
                </div>
                <div className="col-lg-6 col-md-12 col-sm-12">
                  <div className="form-group">
                    <label htmlFor="debrief">Domestic Debrief Minutes</label>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      value={state.domesticDebriefMinutes || ""}
                      onChange={(e) => {
                        let domesticDebriefMinutes = e.target.value;
                        if (
                          domesticDebriefMinutes.trim() === "" ||
                          RegEx.Numeric.test(domesticDebriefMinutes)
                        ) {
                          if (Number(domesticDebriefMinutes) < 1000) {
                            setState((prev) => ({
                              ...prev,
                              domesticDebriefMinutes: domesticDebriefMinutes,
                            }));
                          }
                        }
                      }}
                    />
                  </div>
                </div>
              </>
            )}
            {(state.airlineTypeId === 2 || state.airlineTypeId === 3) && (
              <>
                <div className="col-lg-6 col-md-12 col-sm-12">
                  <div className="form-group">
                    <label htmlFor="reporting">
                      International Reporting Minutes
                    </label>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      value={state.internationalReportingMinutes || ""}
                      onChange={(e) => {
                        let internationalReportingMinutes = e.target.value;
                        if (
                          internationalReportingMinutes.trim() === "" ||
                          RegEx.Numeric.test(internationalReportingMinutes)
                        ) {
                          if (Number(internationalReportingMinutes) < 1000) {
                            setState((prev) => ({
                              ...prev,
                              internationalReportingMinutes:
                                internationalReportingMinutes,
                            }));
                          }
                        }
                      }}
                    />
                  </div>
                </div>
                <div className="col-lg-6 col-md-12 col-sm-12">
                  <div className="form-group">
                    <label htmlFor="debrief">
                      International Debrief Minutes
                    </label>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      value={state.internationalDebriefMinutes || ""}
                      onChange={(e) => {
                        let internationalDebriefMinutes = e.target.value;
                        if (
                          internationalDebriefMinutes.trim() === "" ||
                          RegEx.Numeric.test(internationalDebriefMinutes)
                        ) {
                          if (Number(internationalDebriefMinutes) < 1000) {
                            setState((prev) => ({
                              ...prev,
                              internationalDebriefMinutes:
                                internationalDebriefMinutes,
                            }));
                          }
                        }
                      }}
                    />
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
        <div className="modal-footer">
          <button
            type="button"
            title="Save"
            className="btn btn-primary btn-sm"
            onClick={async (e) => {
              await handleOnSubmitActivityCode(e);
            }}
          >
            <i
              className={`fas fa-${
                state.isSubmitted ? "spinner fa-spin" : "save"
              }`}
            />
            &nbsp;{props.activityCodeId === 0 ? "Add" : "Update"}
          </button>
          &nbsp;&nbsp;
          <button
            type="button"
            title="Cancel"
            className="btn btn-secondary btn-sm"
            onClick={() => {
              props.onClose();
            }}
          >
            <i className="fas fa-times" />
            &nbsp;Close
          </button>
        </div>
      </Modal>
    </>
  );
}
